import { graphql, Link, useStaticQuery } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";

const Places = () => {
  const locations: Queries.AllPlacesQuery = useStaticQuery(graphql`
    query AllPlaces {
      allContentfulLocation(
        filter: { title: { regex: "/^(?!.*(^dummy))/gi" } }
        sort: { title: ASC }
      ) {
        edges {
          node {
            contentful_id
            __typename
            id
            title
            slug
            magicalPlace
            magicalPlacePosition
            images {
              gatsbyImageData(
                formats: WEBP
                quality: 75
                width: 135
                aspectRatio: 1.33
                placeholder: BLURRED
              )
              title
            }
            description {
              raw
            }
            video {
              file {
                contentType
                fileName
                url
              }
            }
            coordinates {
              lon
              lat
            }
          }
        }
      }
    }
  `);
  const data = locations.allContentfulLocation.edges;
  return (
    <div>
      <div className="container mx-auto px-5 py-12 md:py-24">
        <h2 className="font-header text-3xl md:text-7xl lg:text-[88px] lg:w-4/6 mx-auto mb-10 text-c-places-title uppercase">
          Platser <br />i Sandviken
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {data.map((location, key) => {
            const { images, title, coordinates, magicalPlacePosition, slug } =
              location.node;

            return (
              <Link to={`/plats/${slug}`}>
                <div className="group flex bg-white hover:shadow-lg hover:shadow-c-places-shadow/30 transition ease-in-out duration-700 shadow-md items-center gap-x-5">
                  <div className="shrink-0 relative">
                    {images !== null && images.length > 0 && (
                      <>
                        {images[0] !== null &&
                          images[0].gatsbyImageData !== null && (
                            <div>
                              <GatsbyImage
                                alt={
                                  images[0].title
                                    ? images[0].title
                                    : "Platsbild"
                                }
                                image={images[0].gatsbyImageData}
                              />
                            </div>
                          )}
                      </>
                    )}
                    {magicalPlacePosition !== null && magicalPlacePosition > 0 && (
                      <div className="text-white inline-flex group-hover:scale-125 w-14 h-14 transition duration-700 justify-center items-center font-title text-xl absolute -top-5 -left-5">
                        <div className="relative z-[100] mt-1">
                          {magicalPlacePosition}
                        </div>
                        <div className="absolute">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="100%"
                            height="100%"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="#CA005C"
                              d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"
                            />
                          </svg>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="text-left overflow-hidden">
                    <div className="font-bold text-lg leading-5 uppercase font-title">
                      {title}
                    </div>
                    <div className="font-bold text-sm leading-4 uppercase font-title text-c-places-coordinates">
                      {coordinates &&
                        `${coordinates?.lat
                          ?.toString()
                          .slice(0, 10)}, ${coordinates?.lon
                          ?.toString()
                          .slice(0, 10)}`}
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Places;
